<div class="custom-datepicker">  
    <button mat-stroked-button color="primary" matTooltip="Modo de vista" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
      (click)="calendarVisibility(!isViewMenuOpen())" [class.btn-loading]="isLoading">
      <div class="flex items-center">
        <div class="pr-8">
            <span matBadge="{{total()}}" matBadgeOverlap="false"></span>
        </div>
        <div class="flex flex-col p-2 content-center text-center gap-[3px] min-w-[60px] w-20">
          <span *ngIf="showFuture" class="font-light">P. Futuros</span>
          <span *ngIf="!showFuture" class="font-light">P. Pasados</span>
        </div>

        <mat-icon [svgIcon]="isViewMenuOpen() ? 'arrow_drop_up' : 'arrow_drop_down'"></mat-icon>
      </div>
    </button>
  
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isViewMenuOpen()"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayHasBackdrop]="true"
      (detach)="calendarVisibility(false)"
      (backdropClick)="calendarVisibility(false)"
      >
        <div
            class="w-[253px] h-[304px] sm:w-[400px] sm:h-[400px] md:w-[600px] md:h-[500px] lg:w-[800px] lg:h-[600px] p-4 bg-white shadow-lg rounded-lg flex items-center justify-center"
            >
            @if (isLoading) {
              <div class="w-full h-full flex flex-col overflow-hidden" style="padding: 12px 8px;">
                <div class="flex gap-4 h-full">
                  @for (m of [1,2,3]; track m) {
                    <div class="flex-1 flex flex-col gap-1.5">
                      <div class="h-4 w-16 bg-gray-200/70 rounded shimmer-fill"></div>
                      <div class="grid grid-cols-7 gap-px mt-0.5">
                        @for (d of ['L','M','M','J','V','S','D']; track d) {
                          <div class="text-[9px] text-gray-300 text-center font-medium leading-4">{{d}}</div>
                        }
                        @for (d of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35]; track d) {
                          <div class="aspect-square rounded-sm" [class.bg-gray-100]="d <= 31" [class.opacity-30]="d > 28"></div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <full-calendar [options]="calendarOptions"></full-calendar>
            }
        </div>
    </ng-template>  
</div>  

<!-- Popover personalizado con diseño mejorado -->
<mat-menu #popoverMenu="matMenu" [overlapTrigger]="false" class="custom-popover" [xPosition]="'after'" [yPosition]="'below'">
  <div class="p-4 min-w-[200px] max-w-[250px] text-center">
    <div class="text-lg font-bold text-primary">{{ currentEventData?.date | date:'mediumDate' }}</div>
    <div class="mt-2 flex flex-col gap-1 text-sm text-gray-600">
      <div>Con viaje: <span class="font-medium text-green-600">{{ currentEventData?.withTrip }}</span></div>
      <div>Sin viaje: <span class="font-medium text-red-600">{{ currentEventData?.withoutTrip }}</span></div>
      <div>Total: <span class="font-medium">{{ currentEventData?.total }}</span></div>
    </div>
    <button mat-stroked-button color="primary" class="w-full mt-3" (click)="search(currentEventData?.date)">
      Ver detalle
    </button>
  </div>
</mat-menu>

<!-- Botón invisible para disparar el menú -->
<button
  #popoverTrigger="matMenuTrigger"
  [matMenuTriggerFor]="popoverMenu"
  style="position: fixed; top: 0; left: 0; opacity: 0; pointer-events: none;"
></button>
